import React from "react";
import trustedIcon from "../assets/Trusted.webp";
import guaranteedIcon from "../assets/Guranteed_Delivery.webp";
import instockIcon from "../assets/instock.webp";

const TrustedSource: React.FC = () => {
  const benefits = [
    {
      title: "Trusted Source",
      description:
        "Delivered over 50 million pieces of PPE during COVID-19 Pandemic using proven suppliers, including Made in USA resources.",
      icon: trustedIcon,
      style: "w-[45px] h-[57px]",
    },
    {
      title: "Guaranteed Quality",
      description:
        "Exclusive Lifetime Warranty. If there is an issue, we'll fix it, for life.",
      icon: guaranteedIcon,
      style: "w-[80px] h-[49px]",
    },
    {
      title: "In Stock & Ready To Ship",
      description:
        "Large in-stock inventory allows for 24-hour shipping on more items.",
      icon: instockIcon,
      style: "w-[55px] h-[57px]",
    },
  ];

  return (
    <div className="w-full py-[50px] bg-[rgb(247,247,247)]">
      <div className="max-w-[1710px] mx-auto px-[20px]">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-0">
          {benefits.map((benefit, index) => (
            <div key={index} className="text-center group md:px-[15px]">
              {/* Icon */}
              <div className="h-[75px]">
                <div
                  className={`${benefit.style} mx-auto flex items-center justify-center`}
                >
                  <img
                    src={benefit.icon}
                    alt={benefit.title}
                    className="w-full h-full object-contain"
                    loading="lazy"
                  />
                </div>
              </div>

              {/* Title */}
              <h2 className="text-xl font-semibold text-[#000] leading-[1.5] mt-2.5 mb-2 uppercase">
                {benefit.title}
              </h2>

              {/* Description */}
              <p className="text-[#666] leading-[26px] text-[16px] mx-auto max-w-[400px]">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustedSource;
